import React, { useState, useEffect } from "react"
import { Link } from "@reach/router"
import { makeStyles } from "@material-ui/core/styles"
import MenuItem from "@material-ui/core/MenuItem"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import trees from "../static/trees-1.jpg"
import kila from "../static/kila.png"

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 130,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
}))

const Sidenav = props => {
  const classes = useStyles()
  const [data, setData] = useState({})

  //Estructura del conteo por semanas
  const rangeWeeks = [
    "Semana 26-36",
    "Semana 37-47",
    "Semana 48-58",
    "Semana 59-69",
    "Semana 70-80",
    "Semana 81-91",
    "Semana 92-102",
    "Semana 103-113",
  ]

  return (
    <div>
      <ul id="slide-out" className="sidenav">
        <li>
          <div className="user-view">
            <div className="background">
              <img src={trees} width="300" height="300" alt="background" />
            </div>
            <div className="user-img">
              <img className="kila-logo" src={kila} alt="kila-logo" />
            </div>
            <Link to="/mi-perfil/">
              <span className="white-text usuario">{data.building_name}</span>
            </Link>
          </div>
        </li>
        <li>
          <a href="#!" className="subheader">
            Avanzar Siguientes Semanas
          </a>
        </li>
        <li className="weeks">
          <FormControl className={classes.formControl}>
            <Select
              value={props.weekOne}
              onChange={props.handleChange}
              displayEmpty
              className={classes.selectEmpty}
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="">
                <em>Cambiar Semanas</em>
              </MenuItem>
              {rangeWeeks.map((item, key) => (
                <MenuItem value={item}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </li>
        <li>
          <a href="#!" className="subheader">
            Cambiar Semana Actual
          </a>
        </li>
        <li className="weeks">
          <FormControl className={classes.formControl}>
            <Select
              value={props.weekTwo}
              onChange={props.handleDropdown}
              displayEmpty
              className={classes.selectEmpty}
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="">
                <em>Seleccionar Semana</em>
              </MenuItem>
              {props.weeks.map((item, key) => (
                <MenuItem key={key} value={item}>
                  Semana {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </li>
        <li>
          <div className="divider"></div>
        </li>
        <li>
          <span>
            <Link className="goto" to="/kila-home-id-980615">
              Volver a Inicio
              <span role="img" aria-label="house">
                &nbsp;🏠
              </span>
            </Link>
          </span>
        </li>
      </ul>
    </div>
  )
}

export default Sidenav
